export function catalogueRequestHeaders(
  appUrl: string | undefined,
  catalogueOriginOverride?: string | undefined,
): Record<string, string> {
  const headers: Record<string, string> = { Accept: 'application/json' };
  const raw = catalogueOriginOverride?.trim() || appUrl?.trim();
  if (!raw) return headers;
  try {
    headers.Origin = new URL(raw).origin;
  } catch {
    return headers;
  }
  return headers;
}
